import { required } from "@vuelidate/validators";
const osozlesme = {
  data() {
    return {
      osozlesmeData: {
        Baslik: null,
        Baslangictarihi: null,
        Bitistarihi: null,
        Birimid: null,
        Tutar: null,
        Aciklama: null,
        Belgeid: null,
        Uygulamaids: [],
      },
      FormDataType: {
        Baslik: { FieldName: "Baslik", Field: "input", FieldTitle: "Başlık" },
        Baslangictarihi: { FieldName: "Baslangictarihi", Field: "date", FieldTitle: "Başlangıç Tarihi" },
        Bitistarihi: { FieldName: "Bitistarihi", Field: "date", FieldTitle: "Bitiş Tarihi" },
        Birimid: { FieldName: "Birimid", Field: "combobox", FieldTitle: "Birim", ComboData: {}, ComboDataArray: [], Multiple: false },
        Tutar: { FieldName: "Tutar", Field: "input", FieldTitle: "Tutar" },
        Aciklama: { FieldName: "Aciklama", Field: "input", FieldTitle: "Açıklama" },
        Belgeid: { FieldName: "Belgeid", Field: "combobox", FieldTitle: "Belge", ComboData: {}, ComboDataArray: [], Multiple: false },
        Uygulamaids: { FieldName: "Uygulamaids", Field: "combobox", FieldTitle: "Uygulamalar", ComboData: {}, ComboDataArray: [], Multiple: true },
      }



    }
  },
  validations: {
    FormData: {
      Baslik: { required },
      Baslangictarihi: {},
      Bitistarihi: {},
      Birimid: {},
      Tutar: {},
      Aciklama: {},
      Belgeid: {},
      Uygulamaids: {},
    }
  },

  created() {


    this.ActionsFilterGet({ Service: "obirim/gettree", FullData: true, Filter: "" }).then((res) => {
      this.FormDataType.Birimid.ComboDataArray = res.Data
    }); 

    this.ActionsFilterGet({ Service: "okeyvalues", FullData: true, Filter: "&Asc=Kod&Tip=8" }).then((res) => {
      this.FormDataType.Uygulamaids.ComboDataArray = res.Data.map(item => ({
        id: item.Id,
        label: item.Value
      }));
    });

    this.ActionsFilterGet({ Service: "obirimbelge", FullData: true, Filter: "" }).then((res) => {
      this.FormDataType.Belgeid.ComboDataArray = res.Data.map(item => ({
        id: item.Id,
        label: item.Birimadi + " - " + item.Baslik
      }));
    });




  }
}
export default osozlesme